var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"button",staticClass:"icon sign-out-button",class:{destructive: _vm.loggingOut},on:{"click":_vm.clicked}},[_c('v-icon',{attrs:{"name":"log-out"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }